export const volumeRanges = {
    receiveGain: { max: 10, min: -10 },
    trim: { max: 12, min: -12 },
    volume: { max: 50, min: 0 }, // 50 dB of range
};
export function forEachConfig(driverConfig, cb, include = ['mute', 'telephony', 'volume']) {
    var _a, _b;
    const props = [
        'audioInputSources',
        'overflowRooms',
        'soundReinforcement',
    ];
    const ctrls = ['mute', 'volume'];
    for (const prop of props) {
        for (const [id, config] of Object.entries((_a = driverConfig[prop]) !== null && _a !== void 0 ? _a : {})) {
            for (const ctrl of ctrls) {
                if (!include.includes(ctrl))
                    continue;
                const cfg = config[ctrl];
                if (cfg !== undefined)
                    cb([prop, id, ctrl], ctrl, cfg);
            }
        }
    }
    if (driverConfig.assistiveListening) {
        const config = driverConfig.assistiveListening;
        for (const ctrl of ctrls) {
            if (!include.includes(ctrl))
                continue;
            const cfg = config[ctrl];
            if (cfg !== undefined)
                cb(['assistiveListening', ctrl], ctrl, config[ctrl]);
        }
    }
    if (include.includes('mute')) {
        const config = driverConfig.mics;
        if (config)
            cb(['mics'], 'mute', config);
    }
    if (include.includes('volume')) {
        const config = driverConfig.amplifier;
        if (config)
            cb(['amplifier'], 'volume', config);
    }
    if (include.includes('telephony')) {
        for (const [id, config] of Object.entries((_b = driverConfig.telephony) !== null && _b !== void 0 ? _b : {})) {
            cb(['telephony', id], 'telephony', config);
        }
    }
}
export class DuplicateChecker {
    constructor(driverConfig, getKey) {
        this.driverConfig = driverConfig;
        this.getKey = getKey;
        this.isComputed = false;
        // pathsByKey[key][type] = paths;
        this.pathsByKey = {};
    }
    computePathsByKey() {
        this.forEachConfig((path, type, config) => {
            var _a;
            const key = this.getKey(config);
            if (this.pathsByKey[key] === undefined) {
                this.pathsByKey[key] = {};
            }
            const paths = (_a = this.pathsByKey[key][type]) !== null && _a !== void 0 ? _a : [];
            paths.push(path);
            this.pathsByKey[key][type] = paths;
        });
    }
    forEachConfig(cb, include = ['mute', 'telephony', 'volume']) {
        forEachConfig(this.driverConfig, cb, include);
    }
    getDuplicates(config, type) {
        var _a, _b;
        if (!this.isComputed) {
            this.computePathsByKey();
            this.isComputed = true;
        }
        return (_b = (_a = this.pathsByKey[this.getKey(config)]) === null || _a === void 0 ? void 0 : _a[type]) !== null && _b !== void 0 ? _b : [];
    }
    isDuplicate(config, type) {
        return this.getDuplicates(config, type).length > 1;
    }
}
